export const SITUATION_LABEL = 'Situação';
export const SITUATION_OPTIONS = [
    { value: 'requested' as const, label: 'Pedido feito' },
    { value: 'managerApproved' as const, label: 'Aprovada pelo gestor' },
    { value: 'dpApproved' as const, label: 'Validada pelo DP' },
    { value: 'started' as const, label: 'Férias iniciadas' },
    { value: 'completed' as const, label: 'Férias concluídas' },
    { value: 'rejected' as const, label: 'Recusada' },
] as const;

export const MONTH_LABEL = 'Mês';
export const YEAR_LABEL = 'Ano';
export const ALL_MONTHS = 'Todos os meses';
export const ALL_YEARS = 'Todos os anos';

export const SEARCH_PLACEHOLDER = 'Nome ou e-mail';
export const SEARCH_LABEL = 'Colaborador';

export const DOWNLOAD_BUTTON_LABEL = 'Baixar CSV';

export const RESULT_LABEL_TEMPLATE = (kindLabel: string, periodLabel: string, total: number, people: number) => {
    const totalText = total === 1 ? 'solicitação' : 'solicitações';
    const peopleText = people === 1 ? 'pessoa' : 'pessoas';
    return `${kindLabel} em ${periodLabel} · ${total} ${totalText} · ${people} ${peopleText}`;
};

export const EMPTY_STATE_MESSAGE = 'Nenhuma solicitação encontrada com os critérios selecionados.';

export const MONTH_NAMES = [
    'Janeiro',
    'Fevereiro',
    'Março',
    'Abril',
    'Maio',
    'Junho',
    'Julho',
    'Agosto',
    'Setembro',
    'Outubro',
    'Novembro',
    'Dezembro',
] as const;
